module.exports = __webpack_public_path__ + "img/lamels.7574dee7.jpg";